module.exports = __webpack_public_path__ + "static/Marilia_dengue-be66e983201e02e91d36f6542c2b4f06.png";